export default "__VITE_ASSET__B1E6KKN4__"